import type { EditorPlugin } from '../../../types/aha-editor';

const ItalicMarkPlugin: EditorPlugin = {
  name: 'Italic mark plugin',
  mark: {
    type: 'italic',
    props: {
      style: {
        fontStyle: 'italic',
      },
    },
  },
};
export default ItalicMarkPlugin;
